import { api } from "../api_middleware";
import { getEffectiveBaseUrl } from "./serverUrls";
import { UserName } from "./userEndpoints";

export interface PatientJWTRequest {
  user_name: UserName;
  organization_id: string;
  external_member_id: string;
  email?: string;
  phone?: string;
}

export interface PatientJWTResponse {
  jwt: string;
}

export const performDirectTokenCookieExchange = async (
  resLinkParamsId: string,
  organizationId: string,
  token: string,
): Promise<void> => {
  console.log(`[performTokenCookieExchange] Exchanging token for cookie with resLinkParamsId: ${resLinkParamsId}`);

  const baseHttpUrl = getEffectiveBaseUrl();
  const url = new URL("v1/pixels/partners/start", baseHttpUrl);
  url.searchParams.set("res_link_params_id", resLinkParamsId.trim());
  url.searchParams.set("organization_id", organizationId.trim());

  const authToken = `Bearer ${token.trim()}`;

  const response = await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Partner-Authorization": authToken,
    },
    body: JSON.stringify({}),
  });

  if (!response.ok) {
    console.error(`[performTokenCookieExchange] Failed to exchange token for cookie: ${response.statusText}`);
    return;
  }

  console.log(`[performTokenCookieExchange] Successfully exchanged token for cookie.`);
  return;
};

export const getPatientJWT = async (
  organizationId: string,
  externalMemberId: string,
  firstName: string,
  middleName?: string,
  lastName?: string,
  email?: string,
  phone?: string,
): Promise<string> => {
  const patientJWTRequest: PatientJWTRequest = {
    user_name: { first_name: firstName, middle_name: middleName, last_name: lastName },
    organization_id: organizationId,
    external_member_id: externalMemberId,
    email: email,
    phone: phone,
  };
  console.log("[getPatientJWT] request:", patientJWTRequest);
  const patientJWTResponse = await api(
    "v1/pixels/partners/issue-jwt",
    "POST",
    getEffectiveBaseUrl(),
    patientJWTRequest
  ) as PatientJWTResponse;
  console.log("[getPatientJWT] response:", patientJWTResponse);
  return patientJWTResponse.jwt;
}